import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const DEFAULT_VIEWBOX = "0 0 18 12";
const FirstPageIcon = ({ size, viewBox = DEFAULT_VIEWBOX, ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { size, ...rest, viewBox, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M1 0C0.448 0 0 0.448 0 1V11C0 11.552 0.448 12 1 12C1.552 12 2 11.552 2 11V1C2 0.448 1.552 0 1 0ZM8.94922 0.929688C8.7703 0.938391 8.58958 0.996281 8.42383 1.11328L2.65625 5.18359C2.09225 5.58159 2.09225 6.41841 2.65625 6.81641L8.42383 10.8867C9.08683 11.3547 10 10.8813 10 10.0703V1.92969C10 1.32144 9.48598 0.903578 8.94922 0.929688ZM16.9492 0.929688C16.7703 0.938391 16.5896 0.996281 16.4238 1.11328L10.6562 5.18359C10.0922 5.58159 10.0922 6.41841 10.6562 6.81641L16.4238 10.8867C17.0868 11.3547 18 10.8813 18 10.0703V1.92969C18 1.32144 17.486 0.903578 16.9492 0.929688Z",
      fill: rest.fill
    }
  ) });
};
export {
  FirstPageIcon
};
